module.exports = __webpack_public_path__ + "static/media/thumb-matched.7ddc2b4a.png";